
import Banner from "../components/banner/Banner";
import Footer from "../components/footer/Footer";

import Navbar from "../components/navbar/Navbar";

import { useEffect } from "react";

import Shipping from "../components/Shipping";


const ShippingPolicy=()=>{
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return(
        <div className="">
<Navbar/>
 <Banner title="Shipping policy"/>

<Shipping/>
<Footer/>

</div>
    )
}
export default ShippingPolicy;